export function getRuntimeConfig() {
  return ((window as any).__SURVEYSAAS_CONFIG__ || {}) as Record<string, string>
}

export function getRuntimeApiBaseUrl(fallback: string) {
  const runtimeBaseUrl = getRuntimeConfig().VITE_APP_API_BASEURL
  if (runtimeBaseUrl) {
    return runtimeBaseUrl
  }

  const host = window.location.hostname || ''
  if (/^(localhost|127\.0\.0\.1)$/i.test(host) || /\.?surveys?saas\.com$/i.test(host)) {
    return fallback
  }

  console.error('Missing runtime API config: VITE_APP_API_BASEURL')
  return ''
}
